import { render, staticRenderFns } from "./ruleDialog.vue?vue&type=template&id=1d542828&"
import script from "./ruleDialog.ts?vue&type=script&lang=ts&"
export * from "./ruleDialog.ts?vue&type=script&lang=ts&"
import style0 from "./ruleDialog.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports